import DevLog from '../../modules/devlog/Module'
import { IAction } from '../types'

export interface IOnTryAgain {
  (): void
}

const onTryAgainCallbacks = new WeakMap<IAction, IOnTryAgain>()

export function addOnTryAgainToAction(action: IAction, callback: IOnTryAgain) {
  onTryAgainCallbacks.set(action, callback)
}

export function actionHasOnTryAgain(action: IAction) {
  return onTryAgainCallbacks.has(action)
}

export function actionTryAgain(action: IAction) {
  const callback = onTryAgainCallbacks.get(action)
  if (callback) {
    try {
      callback()
    } catch (error) {
      DevLog.error(error, `SW[onTryAgain]`)
    }
  }
}
